import React from 'react'
import SearchTable from './SearchTable'
import Plotting from './LymphoCNV'
import { connect } from 'react-redux'
import { filterAction, cnv_resAction } from '../../actions/action'
import { Row, Col, Button } from 'react-bootstrap'
import { addAlert } from '../../actions/alerts'
import { updateCommentLocal, updateCommentRemote } from '../../actions/comment'
import { Modal } from 'react-bootstrap'

class CNV extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            ploidy: 0,
            seg: true,
            res: true,
            anti: true,
            ploidy: false,
            showModal: false,
            log2Ploidy: 0,
            log2PloidyTmp: 0
        }
        this.plotRef = React.createRef()
    }

    componentDidMount() {
        this.load();
    }

    changePloidy = (x) => {
        this.setState({ ploidy: x })
    }

    changeSeg = (x) => {
        this.setState({ seg: !this.state.seg })
    }

    changeAnti = (x) => {
        this.setState({ anti: !this.state.anti })
    }

    changeRes = (x) => {
        this.props.cnv_resAction(!this.state.res)
        this.setState({ res: !this.state.res })
    }

    load() {
        this.setState({ loaded: true });
    }

    showModal = () => {
        this.setState({ showModal: true })
    }

    hideModal = () => {
        this.setState({ showModal: false })
    }

    changePloidy = () => {
        this.setState({ log2Ploidy: this.state.log2PloidyTmp })
        this.setState({ showModal: false })
    }

    resetLog2Ploidy = () => {
        this.setState({ log2Ploidy: 0 })
        this.setState({ log2PloidyTmp: 0 })
        this.setState({ showModal: false })
    }

    changeLog2Ploidy = (event) => {
        this.setState({ log2PloidyTmp: event.target.value });
    }

    render() {
        if (!this.state.loaded) {
            return (<div>Loading</div>)
        } else {
            return (
                this.props.data === null | this.props.data === undefined ?
                    <h1> select a sample </h1> :
                    !this.props.data[2] & this.props.cnv_res ?
                        <h1> CNV data not available for this sample </h1> :
                        <div>
                            <Row>
                                <Button
                                    style={{ backgroundColor: this.state.seg ? 'gray' : 'orange', borderColor: '#6c757d', margin: "15px" }}
                                    onClick={this.changeSeg}
                                >
                                    {this.state.seg ? 'Hide segments' : 'Show segments'}
                                </Button>
                                <Button
                                    style={{ backgroundColor: this.state.anti ? 'gray' : 'orange', borderColor: '#6c757d', margin: "15px" }}
                                    onClick={this.changeAnti}
                                >
                                    {this.state.anti ? 'Hide antitargets' : 'Show antitargets'}
                                </Button>
                                <Button
                                    style={{ display: 'none', backgroundColor: this.state.res ? 'gray' : 'orange', borderColor: '#6c757d', margin: "15px" }}
                                    onClick={this.changeRes}
                                >
                                    {this.state.res ? 'Change target bin size to 50' : 'Change target bin size to automatic'}
                                </Button>
                                <Button
                                    style={{ background: this.state.log2Ploidy ? '#10E5AA' : '#DDDDDD', margin: "15px", width: '150px' }}  onClick={(e) => this.showModal()}>Ploidy {this.state.log2Ploidy ? this.state.log2Ploidy : '-'}
                                </Button>
                            </Row>
                            {!this.props.data[2] & !this.props.cnv_res ? <h1> CNV data not available for bin size 50 </h1> : <>
                                <div style={{ width: '100%' }} ref={this.plotRef}>
                                    {/* {this.props.data != null && this.props.data[2] ?
                                    <Plotting data={this.props.data} sample={this.props.sample} run={this.props.run} diploidy={this.state.ploidy} /> :
                                    <div></div>} */}
                                    <Plotting
                                        data={this.props.data}
                                        sample={this.props.sample}
                                        run={this.props.run}
                                        diploidy={this.state.log2Ploidy}
                                        seg={this.state.seg}
                                        cnv_res={this.props.cnv_res}
                                        anti={this.state.anti} />
                                </div>

                                <br></br>
                                <Row >
                                    <Col>
                                        <div >
                                            <SearchTable
                                                data={this.props.tab}
                                                table={'CNV'}
                                                trigger={this.props.segmentClick}
                                                scroll={this.plotRef}
                                                log2Ploidy={this.state.log2Ploidy}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </>}
                            <br />
                            <Modal show={this.state.showModal} onHide={this.hideModal} size="lg" centered>
                                <Modal.Header closeButton >
                                    <Modal.Title>Change sample ploidy</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row>
                                        <Col>
                                            Sample ploidy
                                        </Col>
                                        <Col style={{ textAlign: 'center' }}>
                                            Log2 ratio <input style={{ maxWidth: '40%' }} type="number" name="Log2 ratio" value={this.state.log2PloidyTmp} onChange={this.changeLog2Ploidy} />
                                        </Col>
                                        <Col>
                                            Reference copy number: {Number(((2 ** Number(this.state.log2PloidyTmp)) * 2).toFixed(3))}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col style={{ textAlignLast: 'center' }}>
                                            <Button onClick={this.resetLog2Ploidy} >Reset ploidy</Button>
                                        </Col>
                                        <Col style={{ textAlignLast: 'center' }}>
                                            <Button onClick={this.changePloidy} >Confirm</Button>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                            </Modal>

                        </div >
            )
        }
    }
}

//Passing global state as props (redux)
const mapStateToProps = (state) => {
    return {
        globalFilters: state.globalFilters,
        run: state.run,
        sample: state.sample,
        user: state.user,
        preset: state.preset,
        commentLocal: state.comment.commentLocal,
        commentRemote: state.comment.commentRemote,
        cnv_res: state.cnv_res
    }
}
const mapDispatchToProps = { filterAction, addAlert, updateCommentLocal, updateCommentRemote, cnv_resAction } // WARNING THIS SHIT CANNOT BE FUNCTION IT MUST BE AN OBJECT OR YOU WILL WASTE YOUR DAY ON THIS TUTORIALS LIE 
export default connect(mapStateToProps, mapDispatchToProps)(CNV)
